module.exports = __webpack_public_path__ + "static/media/mdo.1e58e759.svg";